<template>
  <div>
    <component
      :is="resolveSectionComponent(section.__typename as SectionComponents)"
      v-for="(section, idx) in data?.index!.hero"
      :key="section.__typename"
      :index="idx"
      :data="section"
    />
    <div v-if="Array.isArray(data?.index!.blocks) && data?.index!.blocks.length">
      <component
        :is="resolveSectionComponent(section.__typename as SectionComponents)"
        v-for="(section, index) in data.index.blocks"
        :key="section.__typename"
        :index="data?.index!.hero?.length > 0 ? index + 1 : index"
        :data="section"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { toHead } from 'vue-datocms'
import type { SectionComponents } from '~/types/components'
import type { ModelApiKey } from '~/types/models'

const config = useRuntimeConfig()
const { resolveSectionComponent } = useResolveComponent()

const route = useRoute()
const { locale } = useI18n()

const { data } = await useAsyncGql('index', {
  locale,
  options: {
    initialCache: false
  }
})

if (data?.value!.index) {
  route.meta.nuxtI18n = data
    ?.value!.index._allPublishTranslationLocales?.filter((x: any) => x.value)
    .map((x: any) => x.locale)
}

const datoHead = toHead((data.value as any).index.seo)
const i18nHeadLinks = useLocaleHeadLinks(data?.value!.index?._modelApiKey as ModelApiKey)

useHead(() => {
  const metaTags = [...(datoHead.meta || [])]

  return {
    title: datoHead.title,
    link: [...i18nHeadLinks],
    meta: [
      {
        hid: 'og:url',
        property: 'og:url',
        content: config.public.appUrl + route.fullPath
      },
      ...metaTags
    ]
  }
})
</script>
